import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p>&copy;2026 Villa AdriArt</p>
    </div>
  );
};

export default Footer;
